import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from 'ems-oauth2-client';
import { CadastrarEditalComponent } from './cadastrar-edital.component';

@NgModule({
  imports:[
    RouterModule.forChild([
      { path: 'cadastraredital', component: CadastrarEditalComponent,  canActivate:[AuthGuard], data:{nome:'/cadastraredital'} }
    ])
  ],
  exports: [RouterModule]
})
export class CadastrarEditalRoutingModule {

}
